export const MAX_CONTENT_WIDTH = '962px'

// id is the anchor the section nav scrolls to
export const QUESTIONNAIRE_SECTIONS = {
  PEOPLE: { id: 'people', heading: '1. People' },
  ESTATE: { id: 'estate', heading: '2. The estate' },
  DEBTS_AND_LIABILITIES: {
    id: 'debts-and-liabilities',
    heading: '3. Debts and liabilities',
  },
  LEGAL_AND_FINANCIAL: {
    id: 'legal-and-financial',
    heading: '4. Legal and financial arrangements',
  },
} as const

// mirrors server/src/probate/api/probate-estates/people/types.ts personalRepresentativeType
export const PERSONAL_REPRESENTATIVE_TYPE = {
  EXECUTOR: 'executor',
  ADMINISTRATOR_WITHOUT_WILL: 'administrator_without_will',
  ADMINISTRATOR_WITH_WILL: 'administrator_with_will',
} as const

export const getPersonalRepresentativeConfig = ({
  hasWill,
}: {
  hasWill?: boolean
}) => {
  if (hasWill === false) {
    return {
      personalRepresentativeType:
        PERSONAL_REPRESENTATIVE_TYPE.ADMINISTRATOR_WITHOUT_WILL,
      heading: '1.3 Administrators',
      cardType: 'Administrator',
      addButtonLabel: 'Add administrator',
    }
  }

  return {
    personalRepresentativeType: PERSONAL_REPRESENTATIVE_TYPE.EXECUTOR,
    heading: '1.3 Executors',
    cardType: 'Executor',
    addButtonLabel: 'Add executor',
  }
}
